import Globe, { GlobeMethods } from 'react-globe.gl';
import earthDart from '../../../assets/img/General/map.jpg';
import countries from '../../../data/custom.geo.json';
import { useEffect, useRef } from 'react';
import { ClassNameProps } from '../../../types/types';

const Globes: React.FC<ClassNameProps> = ({ className }) => {
  //   const isMobile = window.innerWidth < 991.98;

  const N = 20;
  const arcsData = [...Array(N).keys()].map(() => ({
    startLat: (Math.random() - 0.5) * 180,
    startLng: (Math.random() - 0.5) * 360,
    endLat: (Math.random() - 0.5) * 180,
    endLng: (Math.random() - 0.5) * 360,
    // color: '#F1AFFF',
  }));
  const globeRef = useRef<GlobeMethods>();

  useEffect(() => {
    const controls = globeRef.current?.controls();

    if (controls) {
      controls.autoRotate = true;
      controls.enableZoom = false;
      controls.autoRotateSpeed = 0.5;
      controls.rotateSpeed = 0.5;
    }
  }, []);
  if (window.innerWidth < 768) {
    return null;
  }
  return (
    <div className={className}>
      <Globe
        ref={globeRef}
        // основные
        // width={isMobile ? 320 : 674}
        // height={isMobile ? 362 : 764}
        width={674}
        height={764}
        backgroundColor='#020b27'
        showAtmosphere={true}
        atmosphereColor='#3a228a'
        atmosphereAltitude={0.25}
        globeImageUrl={earthDart}
        // hexPolygonsData={countries.features}
        // hexPolygonColor={() => '#21265d'}
        enablePointerInteraction={false}
        // континенты
        polygonsData={countries.features}
        polygonCapColor={() => '#483D8B'}
        polygonSideColor={() => '#878ED1'}
        polygonStrokeColor={() => '#A5AFFF'}
        //Дуги рандомные
        arcsData={arcsData}
        // arcColor={'color'}
        arcColor={() => '#F878E7'}
        arcDashLength={() => Math.random()}
        arcDashGap={() => Math.random()}
        arcDashAnimateTime={5000}
      />
    </div>
  );
};
export default Globes;
